/**
 * Normalize name for search and deduplication
 * - Lowercase
 * - Collapse multiple spaces to single space
 * - Trim whitespace
 * - Remove Arabic diacritics and tatweel
 */
export function normalizeName(s) {
  if (!s || typeof s !== 'string') return '';
  
  return s
    .toLowerCase()
    .replace(/[\u0640\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06ED]/g, '') // Remove Arabic diacritics and tatweel
    .replace(/\s+/g, ' ') // Collapse multiple spaces
    .trim(); // Remove leading/trailing whitespace
}